import { useQueryClient } from 'react-query'

import { ApiQueryKeys } from 'api/common/queryKeys'
import { showToast } from 'components/modals/AlertComponent'
import { usePurpose } from 'api/purposes/queries/usePurpose'

import { useUpdatePurpose } from 'api/purposes/mutations/useUpdatePurpose'
import { useStacks } from 'api/stacks/queries/useStacks'
import { getStackWarnings } from '../utils'

type Args = {
  purposeCode: string
  onSubmit?: () => void
  onCancel: () => void
}

export const useTogglePurposeEnabledStateModalUtils = ({ purposeCode, onCancel, onSubmit }: Args) => {
  const queryClient = useQueryClient()

  const { data: purpose, isLoading: isLoadingPurpose } = usePurpose({
    enabled: !!purposeCode,
    params: {
      purposeCode,
    },
    onError: () => {
      showToast({ content: 'Failed to fetch purpose', type: 'error' })
      onCancel()
    },
  })

  const { mutate: handleUpdatePurpose, isLoading: isUpdatingPurpose } = useUpdatePurpose({
    onMutate: () => {},
    onSuccess: async () => {
      showToast({ content: !purpose?.enabled ? 'Purpose enabled' : 'Purpose disabled', type: 'success' })
      onSubmit?.()
      await queryClient.refetchQueries(ApiQueryKeys.entitlements)
    },
    onError: () => {
      showToast({ content: 'Failed to update purpose', type: 'error' })
    },
  })

  const { data: stacks, isLoading: isLoadingStacks } = useStacks({
    params: {
      purposeCode,
    },
  })

  const isBusy = isUpdatingPurpose

  const warnings = getStackWarnings({ stacks, purposeCode })

  return {
    purpose,
    isBusy,
    warnings,
    handleUpdatePurpose,
    isLoadingDependencies: isLoadingPurpose || isLoadingStacks,
  }
}
